function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgKucoinLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "22.477 0.808 455.0461 498.384",
    width: 455.0461,
    height: 498.384,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M 166.326 250.043 L 313.937 397.689 L 407.114 304.511 C 423.761 289.505 449.265 290.182 465.109 306.027 C 480.954 321.89 481.632 347.376 466.626 364.023 L 343.682 487 C 327.16 503.256 300.676 503.256 284.154 487 L 106.762 309.572 L 106.762 415.033 C 106.762 438.308 87.905 457.183 64.627 457.183 C 41.352 457.183 22.477 438.308 22.477 415.033 L 22.477 84.933 C 22.477 61.655 41.352 42.78 64.627 42.78 C 87.905 42.78 106.762 61.655 106.762 84.933 L 106.762 190.391 L 284.136 13 C 300.639 -3.256 327.142 -3.256 343.648 13 L 466.697 135.96 C 481.704 152.624 481.026 178.11 465.181 193.955 C 449.319 209.818 423.832 210.478 407.186 195.471 L 314.006 102.309 L 166.326 250.043 Z M 314.006 207.858 C 296.932 207.858 281.552 218.123 275.01 233.897 C 268.47 249.652 272.088 267.815 284.136 279.881 C 296.202 291.946 314.364 295.565 330.118 289.042 C 345.891 282.5 356.176 267.12 356.176 250.043 C 356.176 238.868 351.739 228.121 343.826 220.209 C 335.928 212.296 325.201 207.839 314.006 207.839 L 314.006 207.858 Z",
    id: "\\u5F62\\u72B6",
    fill: "#23AF91",
    style: {}
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgKucoinLogo);
export default __webpack_public_path__ + "static/media/KucoinLogo.57ea4f1bd93cb2d6c8eb65aabaa67bd8.svg";
export { ForwardRef as ReactComponent };